import { CONSTANTS } from 'utils/constants';
import { camelizeKeys } from 'humps';
import warehouse from 'services/warehouse';

export const setRetailer = payload => ({
  type: 'SET_RETAIL_PARTNER',
  payload
});

export const getRetailerLogo = ({ slug }) => dispatch => {
  dispatch({type: CONSTANTS.GET_RETAILER_LOGO.REQUEST, slug});
  warehouse.getRetailerLogo({ slug }).then(
    response => {
      dispatch({type: CONSTANTS.GET_RETAILER_LOGO.SUCCESS, payload: camelizeKeys(response)});
    }
  ).catch(
    response => {
      dispatch({type: CONSTANTS.GET_RETAILER_LOGO.FAILURE});
    }
  );
};

export const getRetailerReferralQuestions = ({ slug }) => dispatch => {
  dispatch({type: CONSTANTS.GET_RETAILER_REFERRAL_QUESTION.REQUEST, slug});
  warehouse.getReferralQA({ slug }).then(
    response => {
      dispatch({type: CONSTANTS.GET_RETAILER_REFERRAL_QUESTION.SUCCESS, payload: camelizeKeys(response)});
    }
  ).catch(
    response => {
      dispatch({type: CONSTANTS.GET_RETAILER_REFERRAL_QUESTION.FAILURE});
    }
  );
};

export const clearRetailer = () => ({
  type: 'CLEAR_RETAIL_PARTNER'
});

export default setRetailer;
